module.exports = __webpack_public_path__ + "static/k-plussa-logo-b4c033d84464820994bc501cda6fcaa1.png";